import { createEntityReducer } from 'reducers/account/collections';
import { TYPE } from './actions';

export default createEntityReducer(TYPE);

export const selectGate = (state, name) => state.account.gates[name];
